module.exports = __webpack_public_path__ + "70a2c45e130b40f9fc3b9596b88c3451.pdf";